module.exports = __webpack_public_path__ + "fonts/Inter-Regular.24a88db8.woff2";